"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.NotificationsIcon = exports.Counter = exports.Wrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Notification = _interopRequireDefault(require("../../Notification"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var Wrap = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      mediaQueries = _ref$theme.mediaQueries,
      variant = _ref.variant;
  return _defineProperty({
    position: 'relative',
    marginRight: variant === 'mega' ? space.small : space.base,
    display: 'inline-block'
  }, mediaQueries.small, {
    marginRight: space.large
  });
});
exports.Wrap = Wrap;
var Counter = (0, _styled.default)(_Notification.default)(function (_ref3) {
  var mediaQueries = _ref3.theme.mediaQueries;
  return _defineProperty({
    position: 'absolute',
    top: '-2px',
    right: '-2px',
    zIndex: '1'
  }, mediaQueries.small, {
    top: '-4px',
    right: '1px'
  });
});
exports.Counter = Counter;
var NotificationsIcon = (0, _styled.default)(_Icon.default)(function (_ref5) {
  var mediaQueries = _ref5.theme.mediaQueries;
  return _defineProperty({
    width: '26px'
  }, mediaQueries.small, {
    width: '32px'
  });
});
exports.NotificationsIcon = NotificationsIcon;